<template>
    <div>
        <b-modal v-model="showAgentSelector" :show-close="true" :noCloseOnBackdrop="true" :noCloseOnEsc="true" size="xl" title="Condutores">
            <template #modal-header>
                <div class="w-100" style="padding-bottom: 0%;">
                    <b-row>
                        <b-col class="text-left">
                            <h4>Selecionar Condutores</h4>
                        </b-col>

                        <b-col class="text-right">
                            <button @click.prevent="closeAgentSelector" type="button" aria-label="Close" class="close">×</button>
                        </b-col>
                    </b-row>

                    <b-row align-h="between">
                        <b-col cols="3" style="margin-left:20px;">
                            <el-select v-model="pagination.perPage" @change="perPageChange" placeholder="Por página" class="select-primary pagination-select">
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </b-col>

                        <b-col cols="3" style="margin-right:20px;">
                            <base-input v-model="searchQuery" @keyup="searchChange($event)" prepend-icon="fas fa-search" placeholder="Buscar..."></base-input>
                        </b-col>
                    </b-row>
                </div>
            </template>

            <div>
                <b-table :items="queriedData" :fields="tableColumns" @sort-change="sortChange" select-mode="multi" small :sortDesc="true"
                    head-variant="light"  empty-text="Sem registro de condutores." class="pt-0">

                    <template #cell(selected)="data">
                        <b-form-checkbox v-model="selectedAgentsIndex[data.item.index_key]" @change="selectedAgentsChanged(data)"
                            :disabled="selectedAgentsIndex[data.item.index_key]" class="ml-3">
                        </b-form-checkbox>
                    </template>

                    <template #cell(nickname)="data">
                        <div>
                            {{ data.item.nickname && data.item.nickname.length > 0 ? data.item.nickname : '--' }}
                        </div>
                    </template>
                </b-table>
            </div>

            <template #modal-footer>
                <div class="w-100" style="padding-top: 0%;">
                    <b-row>
                        <b-col class="text-left" align-v="end">
                            Mostrando {{ from + 1 }} - {{ to }} de {{ total }} condutores
                        </b-col>

                        <b-col class="text-left" align-v="end">
                            <base-pagination :current="pagination.currentPage" :per-page="pagination.perPage" :total="total" @change="paginationChanged($event)">
                            </base-pagination>
                        </b-col>

                        <b-col class="text-right" align-v="end">
                            <b-button @click="emitSelectedAgents()" variant="primary" size="sm">Salvar</b-button>
                        </b-col>
                    </b-row>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import usePaginateTable from "../../Composables/usePaginateTable"

export default {
    name: 'AgentSelectorModal',

    setup(props, context) {
        const paginateTable = usePaginateTable(context)

        const total = paginateTable.total
        const from = paginateTable.from
        const to = paginateTable.to
        const queriedData = paginateTable.queriedData
        const pagination = paginateTable.getPagination()
        const billItems = paginateTable.getBillsItems()
        const searchQuery = paginateTable.searchQuery

        function formatDataLocaleString(oldData) { return paginateTable.formatDataLocaleString(oldData) }
        function sortChange(data) { return paginateTable.sortChange(data) }
        function createFuseSearch(keys) { return paginateTable.createFuseSearch(keys) }
        function setBillItems(items) { return paginateTable.setBillsItems(items) }

        return {
            total, from, to, queriedData, pagination, billItems, searchQuery,
            formatDataLocaleString, sortChange, createFuseSearch, setBillItems
        }
    },

    props:{
        showAgentSelector:{
            type: Boolean,
            default: false,
        },

        conductors: {
            type: Array | Object,
            default:()=>{ [] | {} }
        }
    },

    computed: {
        ...mapGetters('auth', {
            user: 'user',
            place: 'getPlace',
        }),

      ...mapGetters('agent', {
            agents: 'getAgents',
        }),

        activeAgents(){
            return this.agents.filter(agent => (agent.active === true || agent.active === 'true')).map(function(value, index){
                value.index_key = index
                value.selected = false
                return value
            })
        },

    },

    watch: {
        agents(newValue, oldValue){
            if(newValue){
                this.recreateSearchableTable()
            }
        },

        showAgentSelector(newValue, oldValue){
            if(newValue){
                this.verifySelectedAgents()
            }
        },
    },

    data() {
        return {
            selectedAgentsIndex: [], selectedAgents: [],
            tableColumns: [
                { key: 'selected', label: '', sortable: false, }, { key: 'name', label: 'Nome', sortable: true, },
                { key: 'nickname', label: 'Apelido', sortable: true, }, { key: 'City.name', label: 'Cidade', sortable: true, },
                { key: 'Place.name', label: 'Responsável', sortable: true, },
            ],
        }
    },

    methods: {
      ...mapActions('agent', [
            "getAllAgents",
        ]),

        perPageChange(perPage) {
            this.pagination.perPage = perPage
            this.pagination.currentPage = 1
            this.reloadTable = true
            setTimeout(this.removeLoading, 0)
        },

        paginationChanged(page) {
            this.reloadTable = true
            this.pagination.currentPage = page;
            setTimeout(this.removeLoading, 0)
        },

        closeAgentSelector(){
            this.searchQuery = ''
            this.pagination.currentPage = 1
            this.$emit('closeAgentSelector', false)
        },

        recreateSearchableTable() {
            this.activeAgents.length > 0 ? this.setBillItems(this.activeAgents) : this.setBillItems([])
            this.createFuseSearch(["name", "nickname", "City.State.name", "Place.City.name", "Place.name"])
        },

        verifySelectedAgents(){
            var vm = this
            if(this.conductors.length > 0){
                this.activeAgents.map(function(value, index){
                    var existing_conductors = vm.conductors.filter(function(val, idx){
                        if(val.uuid == value.uuid){
                            val.index_key = value.index_key
                            return val
                        }
                    })

                    if(existing_conductors.length > 0){
                        const _condutor = existing_conductors[existing_conductors.length - 1]
                        value.selected = _condutor.active
                        vm.selectedAgentsIndex[_condutor.index_key] = _condutor.active
                    }
                })
            }
        },

        selectedAgentsChanged(agent) {
            let _currentAgent = this.activeAgents.find(a => a.index_key == agent.item.index_key)
            let selectedAgent = this.activeAgents[_currentAgent.index_key]
            selectedAgent.selected = !selectedAgent.selected

            const agent_exists = this.selectedAgents.some(agent => agent.index_key == selectedAgent.index_key)

            if(!agent_exists){
                this.selectedAgents.push(selectedAgent)
            }
            else{
                const selected_agent_index = this.selectedAgents.findIndex(agent => agent.index_key == selectedAgent.index_key)
                if(selected_agent_index >= 0){
                    this.selectedAgents[selected_agent_index] = selectedAgent

                    if(!selectedAgent.selected){
                        this.selectedAgents.splice(selected_agent_index, 1)
                    }
                }
            }
        },

        emitSelectedAgents(){
            this.$emit('emitSelectedAgents', this.selectedAgents)
            this.closeAgentSelector()
        },
    },

    mounted() {
        if(this.user){
            const UUID = this.user.uuid || this.place.janooUserUuid
            this.getAllAgents(UUID)
        }

        this.verifySelectedAgents()
        this.recreateSearchableTable()
    },

}
</script>

<style>

.table {
    width: auto !important;
}


</style>
